import './styles/login.scss'

import { getBackendUrl, getApiObject, commonHeaders, hasSpecialChars, makeBorderRed, removeBorder} from './common';

const accountInput = document.getElementById("account");

var backend_url = undefined;
var api = undefined;
var displayMessageDialog = undefined;
var accountField = undefined;

const autoCheckAccount = function() {
    console.log("Validating account details.");

    let account = accountField.value;

    if (hasSpecialChars(account, "name")) {
        makeBorderRed(accountField);
        displayMessage("Account name has invalid charecters.", "red");
        return;
    }

    removeBorder(accountField);

    if (account.length < 3) {
        return;
    }

    displayMessage("Validating account name.");

    let payload = {
        "name" : account
    }

    api.postData("/account/name_check", commonHeaders, [], payload, function(data) {
        let message = "Account Name taken. Please try a different name";
        if (!data.status) {
            console.error("Failure in fetching availability.");
            displayMessage("We are facing technical issues. Please try again later.", "red");
            return;
        }
        if (data.data.account_exists) {
            console.log(message)
            displayMessage("Account Name taken. Please try a different name", "red");
            return
        }

        message = "Account name available. Click on Submit to Proceed.";
        displayMessage(message);
    });
}

function displayMessage(message, colour) {

    displayMessageDialog.innerHTML = message;
    displayMessageDialog.style.color = colour || "black";
}

var validateLogin = function (response) {
    if (response.status == true) {
            console.log("Registration Success!. Saving session.");
            let data = response.data[0];
            let account = data.name;

            if (!account) {
                let emessage = "Some error occured.";
                console.error(emessage);
                displayMessage(emessage);
            }

            displayMessage("Voila!, account "+account+" created. You will be redirected to login page.");

            setTimeout(function() {
                window.location = "/index.html?account_type=admin&account="+account+"&email="+btoa(data.admin)+"&refer=register_page";
            }, 2000);

    } else {
            let message = "Account creation failed.";
            console.log(message);
            if (response.message){
                message = response.message;
            }

            displayMessage(message, "red");
    }
}

function fieldHasInvalidCharecter(e) {
    console.log(e);
    let isNameInvalid = false;
    if (e.target.id == "admin_name") {
        isNameInvalid = hasSpecialChars(e.target.value, "name")
    } else if (e.target.id == "username") {
        isNameInvalid = hasSpecialChars(e.target.value, "email")
    }

    if (isNameInvalid) {
        let id = e.target.id;
        makeBorderRed(e.target);
        displayMessage("Invalid charecters in "+id.replace("_", " "), "red");
        return;
    } 
    console.log("remove border")
    removeBorder(e.target)
}

function onkeypressevent(e) {
    fieldHasInvalidCharecter(e);
}

function onchange(e) {
    fieldHasInvalidCharecter(e);
}

function initUi() {
    accountInput.addEventListener("change", function(e) {
        console.log("Account name input.");
        setTimeout(autoCheckAccount, 500);
    });

    let registerLink = document.getElementById("register_link");
    let registerForm = document.getElementById("register_form");
    accountField = registerForm.querySelector("#account");
    let adminNameField = document.getElementById("admin_name");
    let usernameField = registerForm.querySelector("#username");
    let passwordField = registerForm.querySelector("#password");

    displayMessageDialog = document.getElementById("displayMessage");

    [adminNameField, usernameField].forEach(element => {
        console.log("Adding event listeners.");
        element.addEventListener("keyup", onkeypressevent);
        // element.addEventListener("change", onchange)
    });

    registerLink.addEventListener("click", (e) => {
        e.preventDefault();

        const enteredAccount = accountField.value;
        const enteredAdminName = adminNameField.value;
        const enteredUsername = usernameField.value;
        const enteredPassword = passwordField.value;

        if (!enteredAccount || !enteredUsername || !enteredPassword) {
            displayMessage("Please fill all fields.", "red");
        } else {
            if (hasSpecialChars(enteredAccount, "name") || hasSpecialChars(enteredAdminName, "name") || hasSpecialChars(enteredUsername, "email")) {
                displayMessage("Invalid charecters. No special charectes allowed in account name and admin name.", "red");
                return;
            } 

            const loginData = {
                name : enteredAccount,
                admin_name : enteredAdminName,
                admin_email: enteredUsername,
                admin_password: enteredPassword,
            };
            api.postData("/account/create", commonHeaders, [], loginData, validateLogin);
        }
    });
}

window.onload = function () {
    console.log("Registration page loaded.");
    backend_url = getBackendUrl();

    if (!backend_url) {
        console.error("Unable to set backend url. Exitting.");
        return;
    }

    console.log("Backend URL is set. "+backend_url);

    api = getApiObject(backend_url);
    initUi();
    // initLogic();
}